export default "__VITE_ASSET__B8QohZ_e__"